module.exports = __webpack_public_path__ + "static/media/background.18fc2db8.jpg";